import { render } from "./AddNewSpace.vue?vue&type=template&id=21994e21&scoped=true"
import script from "./AddNewSpace.vue?vue&type=script&lang=js"
export * from "./AddNewSpace.vue?vue&type=script&lang=js"

import "./AddNewSpace.vue?vue&type=style&index=0&id=21994e21&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21994e21"]])

export default __exports__